import { queryOptions, useQuery } from '@tanstack/react-query';
import { AdminQueryValues } from '../../enums/adminQueryParametersEnum';
import { administratorApi } from '../api/administratorApi';

/** Query key factory for administrator queries. */
export const administratorKeys = {
  all: ['administrator'] as const,
  params: () => [...administratorKeys.all, 'params'] as const,
  param: (keyParameter: AdminQueryValues) =>
    [...administratorKeys.params(), keyParameter] as const,
};

/** Builds shared query options for an administrator parameter key. */
export const getAdminParametersQueryOptions = (
  keyParameter: AdminQueryValues
) =>
  queryOptions({
    queryKey: administratorKeys.param(keyParameter),
    queryFn: () => administratorApi.getAdminParameters(keyParameter),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

/** Compatibility wrapper for incremental migration to query option factories. */
export function useGetAdminParametersQuery(keyParameter: AdminQueryValues) {
  return useQuery(getAdminParametersQueryOptions(keyParameter));
}
